import PropTypes from 'prop-types';
import ImageAsync from '../native/ImageAsync';

const CardBasicComponent = ({ items, click }) => {

    const handleClick = (e) => {
        click(e);
    }

    return (
        <>
            {
                items.map((item, index) => {
                    return (
                        <div key={'cb_' + index} className='w-full rounded-md border shadow flex justify-start items-center p-2 mt-4'
                            onClick={() => { handleClick(item) }}>
                            <ImageAsync className="image-spot" src={item.imageUrl} alt={item.name}/>
                            <span className='ml-4'>
                                {item.name}
                            </span>
                        </div>
                    )
                })
            }
        </>
    );
};

CardBasicComponent.propTypes = {

    items: PropTypes.array,
    click: PropTypes.func

};

export default CardBasicComponent;
